document.addEventListener('DOMContentLoaded', () => {
    const breadcrumbLinks = document.querySelectorAll('.breadcrumbs__not-last-breadcrumb');
    const breadcrumbsToggle = document.querySelector('.breadcrumbs__ellipsis');

    if (breadcrumbsToggle && breadcrumbLinks) {
        breadcrumbsToggle.addEventListener('click', () => {
            breadcrumbLinks.forEach(function(breadcrumb) {
                breadcrumb.classList.toggle('breadcrumbs__show-additional-links');
            });
            breadcrumbsToggle.remove();
        });
    }
});